import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const PagesContext = createContext([]);

export const PagesProvider = ({ children }) => {
  const [pages, setPages] = useState([]);
  useEffect(() => {
    api.get("/pages").then(({ data }) => setPages(data)).catch(() => setPages([]));
  }, []);
  return <PagesContext.Provider value={pages}>{children}</PagesContext.Provider>;
};

export const usePages = () => useContext(PagesContext);
